import {CountryDriverConceptType, RegionalCostsState} from './types';

export const initCountrySalaryDefinition = {
  id: null,
  salaryType: null,
  dayOfWeek: null,
  startTime: '01:00',
  endTime: '16:00'
};

export const initCountryDriverConceptType: CountryDriverConceptType = {
  id: null,
  name: null,
  description: null,
  multiplicationFactor: null,
  dailyAllowance: null
};

export const initialCountrySpecificCostData = {
  countryDriverConceptTypes: {
    list: null,
    countryDriverConceptType: null
  },
  countrySalaryDefinition: {
    list: null,
    messages: []
  }
};

export const initialCountryYearSpecificCostData = {
  vehicleCost: null,
  vehicleTypeCosts: {
    list: null
  },
  driverCost: null,
  qualityChecked: false
};

export const countryCostData = {
  countriesCostYears: null,
  ...initialCountrySpecificCostData,
  ...initialCountryYearSpecificCostData
};

export const regionalCostsInitialState: RegionalCostsState = {
  ...countryCostData
};
